import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BestoranteService } from "src/app/services/bestorante";

@Component({
  selector: "app-calculator",
  templateUrl: "./calculator.component.html",
  styleUrls: ["./calculator.component.scss"],
})
export class CalculatorComponent implements OnInit {
  @Input() type: string;

  @Input() amount: number;
  @Input() amountStr = "";

  @Output() changed = new EventEmitter();
  @Output() layoutChanged = new EventEmitter();
  @Output() external = new EventEmitter();

  amountCompStr: string;
  addends: number[] = [];

  additionActive = false;

  currentCalcButtons: { type: string; withInput: boolean; buttons: any[] };

  calcButtons = {
    type: "1",
    withInput: true,
    buttons: [
      { label: "C", type: "clear" },
      { label: "7", value: "7", type: "value" },
      { label: "8", value: "8", type: "value" },
      { label: "9", value: "9", type: "value" },
      {
        label: "0.5",
        value: ".5",
        type: "fraction",
      },

      { label: "4", value: "4", type: "value" },
      { label: "5", value: "5", type: "value" },
      { label: "6", value: "6", type: "value" },
      { label: ".", type: "dot" },

      { label: "1", value: "1", type: "value" },
      { label: "2", value: "2", type: "value" },
      { label: "3", value: "3", type: "value" },
      { label: "0", value: "0", type: "value" },
    ],
  };

  calcButtons2 = {
    type: "2",
    withInput: false,
    buttons: [
      { label: "7", value: "7", type: "value" },
      { label: "8", value: "8", type: "value" },
      { label: "9", value: "9", type: "value" },
      { label: "C", type: "clear" },

      { label: "4", value: "4", type: "value" },
      { label: "5", value: "5", type: "value" },
      { label: "6", value: "6", type: "value" },
      { label: ".", type: "dot" },

      { label: "1", value: "1", type: "value" },
      { label: "2", value: "2", type: "value" },
      { label: "3", value: "3", type: "value" },
      { label: "0", value: "0", type: "value" },
    ],
  };

  calcButtons3 = {
    type: "3",
    withInput: false,
    buttons: [
      { label: "7", value: "7", type: "value" },
      { label: "8", value: "8", type: "value" },
      { label: "9", value: "9", type: "value" },
      {
        icon: "backspace-outline",
        type: "back",
      },

      { label: "4", value: "4", type: "value" },
      { label: "5", value: "5", type: "value" },
      { label: "6", value: "6", type: "value" },
      { label: "+", type: "add" },

      { label: "1", value: "1", type: "value" },
      { label: "2", value: "2", type: "value" },
      { label: "3", value: "3", type: "value" },
      { label: "=", type: "equals" },

      { label: "0", value: "0", type: "value" },
      { label: ".", type: "dot" },
      {
        label: ".50",
        value: ".5",
        type: "fraction",
      },
      { icon: "cash-outline", value: "bills", type: "layoutchange" },
    ],
  };

  calcButtons4: { type: string; withInput: boolean; buttons: any[] };

  calcButtons4EUR = {
    type: "4",
    withInput: false,
    buttons: [
      { label: "10€", value: "10", type: "instantadd" },
      { label: "20€", value: "20", type: "instantadd" },
      { label: "50€", value: "50", type: "instantadd" },
      { label: "100€", value: "100", type: "instantadd" },

      { label: "0.50€", value: ".5", type: "instantadd" },
      { label: "1€", value: "1", type: "instantadd" },
      { label: "2€", value: "2", type: "instantadd" },
      { label: "5€", value: "5", type: "instantadd" },

      { label: "0.05€", value: "0.05", type: "instantadd" },
      { label: "0.10€", value: "0.10", type: "instantadd" },
      { label: "0.20€", value: "0.20", type: "instantadd" },
      {
        icon: "keypad",
        value: "numpad",
        type: "layoutchange",
      },
    ],
  };

  calcButtons4DKK = {
    type: "4",
    withInput: false,
    buttons: [
      { label: "DKK 100", value: "100", type: "instantadd" },
      { label: "DKK 200", value: "200", type: "instantadd" },
      { label: "DKK 500", value: "500", type: "instantadd" },
      { label: "DKK 1000", value: "1000", type: "instantadd" },

      { label: "DKK 5", value: "5", type: "instantadd" },
      { label: "DKK 10", value: "10", type: "instantadd" },
      { label: "DKK 20", value: "20", type: "instantadd" },
      { label: "DKK 50", value: "50", type: "instantadd" },

      { label: "DKK 0.50", value: "0.5", type: "instantadd" },
      { label: "DKK 1", value: "1", type: "instantadd" },
      { label: "DKK 2", value: "2", type: "instantadd" },
      {
        icon: "keypad",
        value: "numpad",
        type: "layoutchange",
      },
    ],
  };

  lastEventPointerType = null;

  constructor(private besto: BestoranteService) { }

  public ngOnInit() {
    if (this.besto.restaurant && this.besto.restaurant.cur === "DKK") {
      this.calcButtons4 = this.calcButtons4DKK;
    } else {
      this.calcButtons4 = this.calcButtons4EUR;
    }
    switch (this.type) {
      case "2":
        this.currentCalcButtons = this.calcButtons2;
        break;
      case "3":
        this.currentCalcButtons = this.calcButtons3;
        break;
      case "4":
        this.currentCalcButtons = this.calcButtons4;
        break;
      default:
        this.currentCalcButtons = this.calcButtons;
        break;
    }
  }

  public click(bu, event) {
    if (event) {
      if (
        this.lastEventPointerType === "touch" &&
        event.pointerType === "mouse"
      ) {
        this.lastEventPointerType = event.pointerType;
        return;
      }
      this.lastEventPointerType = event.pointerType;
      event.preventDefault();
      event.cancelBubble = true;
      if (event.srcEvent) {
        event.srcEvent.cancelBubble = true;
        event.srcEvent.stopPropagation();
      }
    }

    if (!this.amountCompStr) {
      this.amountCompStr = this.amount ? "" + this.amount : "";
    }

    if (bu) {
      if (bu.type) {
        switch (bu.type) {
          case "value":
            this.amountCompStr = this.handleValue(
              bu,
              this.amountCompStr,
              this.addends,
            );
            break;
          case "fraction":
            this.amountCompStr = this.handleFraction(
              bu,
              this.amountCompStr,
              this.addends,
            );
            break;
          case "instantadd":
            ;[
              this.addends,
              this.amount,
              this.amountCompStr,
            ] = this.handleInstantAdd(bu, this.addends, this.amount);
            break;
          case "add":
            ;[this.amountCompStr, this.additionActive] = this.handleAdd(

              this.amountCompStr,
              this.additionActive,
            );
            break;
          case "equals":

            ;[
              this.amountCompStr,
              this.amount,
              this.addends,
              this.additionActive,
            ] = this.handleEquals(
              this.amount,
              this.amountCompStr,
              this.addends,
              this.additionActive,
            );
            break;
          case "back":
            this.amountCompStr = this.handleBackSpace(
              this.amountCompStr,
              this.addends,
            );
            break;
          case "clear":
            this.handleClear();
            break;
          case "dot":
            this.amountCompStr = this.handleDot(this.amountCompStr);
            break;
          case "layoutchange":
            if (bu.value === "numpad") {
              this.currentCalcButtons = this.calcButtons3;
            } else if (bu.value === "bills") {
              this.currentCalcButtons = this.calcButtons4;
              this.amountCompStr = this.handleLayoutChange(
                this.amountCompStr,
                this.addends,
              );
              this.additionActive = false;
            }
            this.layoutChanged.next(this.currentCalcButtons.type);
            break;
        }
      }

      if (bu.external) {
        this.external.next(bu);
        return;
      }
    }

    if (!this.additionActive && this.amountCompStr !== "") {
      this.amount = parseFloat(this.amountCompStr);
      this.amountStr = Number(this.amount).toFixed(2);
    } else if (this.additionActive) {
      this.amountStr = this.amountCompStr;
    }

    if (
      this.currentCalcButtons.type === "3" ||
      this.currentCalcButtons.type === "4"
    ) {
      this.changed.next([this.amount, this.amountCompStr, this.addends]);
    } else {
      this.changed.next(this.amount);
    }
  }

  handleValue(button, amountCompStr, addends) {
    if (
      addends.length === 0 ||
      (addends.length > 0 && this.amountCompStr.includes(" + "))
    ) {
      return (amountCompStr += button.value);
    }
    return amountCompStr;
  }

  handleFraction(button, amountCompStr, addends) {
    if (addends.length > 0 && !amountCompStr.includes(" + ")) {
      return amountCompStr;
    }

    if (amountCompStr.length === 0) {
      return "0" + button.value;
    }

    const tempAddendsArr = amountCompStr.split(" + ");
    // prevent an addend to have multiple fractions
    if (!tempAddendsArr[tempAddendsArr.length - 1].includes(".")) {
      if (tempAddendsArr[tempAddendsArr.length - 1] === "") {
        amountCompStr = amountCompStr + "0" + button.value;
      } else {
        amountCompStr = amountCompStr + button.value;
      }
    }
    return amountCompStr;
  }

  handleInstantAdd(button, addends, amount) {
    addends.push(Number(parseFloat(button.value).toFixed(2)));
    amount = addends.reduce((partialSum, a) => partialSum + a, 0);

    return [addends, amount, String(amount)];
  }

  handleAdd(amountCompString, additionActive: boolean) {
    if (
      amountCompString === "" ||
      amountCompString.endsWith(".") ||
      amountCompString.endsWith(" + ")
    ) {
      return [amountCompString, additionActive];
    }

    amountCompString = amountCompString + " + ";
    additionActive = true;

    return [amountCompString, additionActive];
  }

  handleEquals(amount: number, amountCompStr: string, addends: number[], additionActive) {
    const tempAddendsArr = amountCompStr.split(" + ");
    if (
      tempAddendsArr[tempAddendsArr.length - 1] &&
      !tempAddendsArr[tempAddendsArr.length - 1].endsWith(".")
    ) {
      if (addends.length === 0) {
        addends = tempAddendsArr.map(addend => parseFloat(addend));
      } else {
        addends = addends.concat(tempAddendsArr.slice(1).map(addend => parseFloat(addend)));
      }
      amount = addends.reduce((partialSum, a) => partialSum + a, 0);

      amountCompStr = String(amount);
      additionActive = false;
    }

    return [amountCompStr, amount, addends, additionActive];
  }

  handleBackSpace(amountCompStr, addends) {
    // delete last character only if there hasn't been any addition operation
    // or if there are characters in addition to last equation's result
    if (
      addends.length === 0 ||
      (amountCompStr.includes(" + ") && !amountCompStr.endsWith(" + "))
    ) {
      amountCompStr = amountCompStr.substring(0, amountCompStr.length - 1);
      // delete plus sign together with surrounding whitespace
    } else if (amountCompStr.endsWith(" + ")) {
      amountCompStr = amountCompStr.substring(0, amountCompStr.length - 3);
    }

    return amountCompStr;
  }

  handleClear() {
    this.amountCompStr = "";
    this.amountStr = "";
    this.addends = [];
    this.amount = 0;
    this.additionActive = false;
  }

  handleDot(amountCompStr) {
    if (!amountCompStr || amountCompStr.length === 0) {
      return "0.";
    }

    const tempAddendsArr = amountCompStr.split(" + ");
    if (!tempAddendsArr[tempAddendsArr.length - 1].includes(".")) {
      amountCompStr = amountCompStr + ".";
    }
    return amountCompStr;
  }

  handleLayoutChange(
    amountCompStr: string,
    addends: number[],
  ) {
    if (addends.length === 0) {
      amountCompStr = "";
    } else {
      amountCompStr = "" + addends.reduce((partialSum, a) => partialSum + a, 0);
    }
    return amountCompStr;
  }

  getButtonColor(button) {
    if (button.type === "layoutchange") {
      return "tertiary";
    } else if (button.type === "add" || button.type === "equals") {
      return "primary";
    } else if (button.type === "clear" || button.type === "back") {
      return "danger";
    }
    return "light";
  }
}
